(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quick-add"] && !Shopify.designMode) return;
  try {
    // Virtual Try On Modal/Drawer Handler
  document.addEventListener('DOMContentLoaded', function() {
    const tryOnButtons = document.querySelectorAll('.virtual-try-on__button[data-legacy-studio]');
    
    tryOnButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const variantId = this.dataset.variantId;
        const productId = this.dataset.productId;
        const productTitle = this.dataset.productTitle;
        
        openStudioWithVariant(variantId, productId, productTitle);
      });
    });
    
    function openStudioWithVariant(variantId, productId, productTitle) {
      const isMobile = window.innerWidth < 750;
      
      // Find existing studio on page
      const existingStudio = document.querySelector('[id^="oatmeal-studio-"]');
      
      if (!existingStudio) {
        console.error('Oatmeal Studio section not found on page');
        return;
      }
      
      // Clone the studio
      const studioClone = existingStudio.cloneNode(true);
      studioClone.id = studioClone.id + '-modal';
      studioClone.dataset.preselectedVariant = variantId;
      
      // Create modal or drawer
      if (isMobile) {
        createDrawer(studioClone, variantId);
      } else {
        createModal(studioClone, variantId);
      }
    }
    
    function createModal(studioClone, variantId) {
      const modal = document.createElement('div');
      modal.className = 'oatmeal-studio-modal';
      modal.innerHTML = `
        <div class="studio-backdrop"></div>
        <div class="modal-content">
          <button class="studio-close" aria-label="Close">×</button>
          <div class="modal-body"></div>
        </div>
      `;
      
      modal.querySelector('.modal-body').appendChild(studioClone);
      document.body.appendChild(modal);
      
      // Trigger variant selection after a brief delay
      setTimeout(() => {
        const event = new CustomEvent('oatmeal:selectVariant', {
          detail: { variantId: variantId }
        });
        studioClone.dispatchEvent(event);
      }, 100);
      
      // Animate in
      requestAnimationFrame(() => {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      });
      
      // Close handlers
      modal.querySelector('.studio-close').addEventListener('click', () => closeModal(modal));
      modal.querySelector('.studio-backdrop').addEventListener('click', () => closeModal(modal));
      
      // ESC key
      const escHandler = (e) => {
        if (e.key === 'Escape') {
          closeModal(modal);
          document.removeEventListener('keydown', escHandler);
        }
      };
      document.addEventListener('keydown', escHandler);
    }
    
    function createDrawer(studioClone, variantId) {
      const drawer = document.createElement('div');
      drawer.className = 'oatmeal-studio-drawer';
      drawer.innerHTML = `
        <div class="studio-backdrop"></div>
        <div class="drawer-content">
          <div class="drawer-header">
            <div class="drawer-handle"></div>
            <button class="studio-close" aria-label="Close">×</button>
          </div>
          <div class="drawer-body"></div>
        </div>
      `;
      
      drawer.querySelector('.drawer-body').appendChild(studioClone);
      document.body.appendChild(drawer);
      
      // Trigger variant selection
      setTimeout(() => {
        const event = new CustomEvent('oatmeal:selectVariant', {
          detail: { variantId: variantId }
        });
        studioClone.dispatchEvent(event);
      }, 100);
      
      // Animate in
      requestAnimationFrame(() => {
        drawer.classList.add('active');
        document.body.style.overflow = 'hidden';
      });
      
      // Close handlers
      drawer.querySelector('.studio-close').addEventListener('click', () => closeDrawer(drawer));
      drawer.querySelector('.studio-backdrop').addEventListener('click', () => closeDrawer(drawer));
    }
    
    function closeModal(modal) {
      modal.classList.remove('active');
      document.body.style.overflow = '';
      setTimeout(() => modal.remove(), 300);
    }
    
    function closeDrawer(drawer) {
      drawer.classList.remove('active');
      document.body.style.overflow = '';
      setTimeout(() => drawer.remove(), 300);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
